import { useFetchDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import CategorizationsProjectFormCst from "./CategorizationsProjectFormCst";
import useSWRMutation from "swr/mutation";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";
import { useAddEditCategorizationsProject } from "./hooks/useAddEditCategorizationsProject";

const CategorizationsProject: React.FC = () => {
  const { t } = useTranslation(["projects-page"]);
  const { idProject, id } = useParams();
  const navigate = useNavigate();

  // CUSTOM API FOR APPLICATION/JSON-PATCH+JSON
  const { trigger: triggerCategorizationsProjects } = useSWRMutation(
    ServicesURL.postProjectsCategorizations.replace(
      ":budgetProjectId",
      `${idProject}`,
    ),
    (url: string, arg: { arg: any }) =>
      fetcher<any>(`${url}`, MethodType.POST, { ...arg.arg }),
  );

  const { dataDetail: dataProject } = useFetchDetail(
    `${ServicesURL.getProjects}`,
    idProject,
  );

  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.getProjectsCategorizations.replace(
      ":budgetProjectId",
      `${idProject}`,
    ),
    "?macroCategories",
    PagesID["projects.categorizations"],
  );

  const { columns: MacroCategoriesColumns } = useFetchDetail(
    ServicesURL.getProjectsCategorizations.replace(
      ":budgetProjectId",
      `${idProject}`,
    ),
    "?macroCategories",
    PagesID["projects.categorizations.categories"],
  );

  const {
    onSubmit,
    setOpenConfirmStatus,
    openConfirmStatus,
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetDetailAssociations,
    openAssociations,
    setAccountsAssociation,
    accountsAssociation,
  } = useAddEditCategorizationsProject(
    triggerCategorizationsProjects,
    mutate,
    dataDetail,
    dataProject?.dto,
  );

  return (
    <AnimationFadeIn>
      <CategorizationsProjectFormCst
        row={dataDetail}
        columns={columns}
        detailColumns={MacroCategoriesColumns}
        onSubmit={onSubmit}
        backButton={() => {
          navigate(-1);
        }}
        setOpenAssociation={(accessorKey, open, detailForm) =>
          setOpenAssociation(accessorKey, open, detailForm)
        }
        handleDelete={(accessorKey, el) => handleDelete(accessorKey, el)}
        handleAssociation={(accessorKey, value) =>
          handleAssociation(accessorKey, value)
        }
        getValues={(accessorKey) => getValues(accessorKey)}
        association={openAssociations}
        resetDetailAssociations={resetDetailAssociations}
        setAccountsAssociation={setAccountsAssociation}
        accountsAssociation={accountsAssociation}
        dataProject={dataProject.dto || []}
      />
      <ModalConfirmsCst
        open={!!openConfirmStatus}
        title={t("outcome-item", { ns: "modal" })}
        description={t("outcome-item", { ns: "modal" })}
        onCallBackClosed={() => {
          setOpenConfirmStatus(undefined);
        }}
        callBackConfirmed={() => {
          mutate();
          setOpenConfirmStatus(undefined);
        }}
        status={openConfirmStatus}
      />
    </AnimationFadeIn>
  );
};

export default CategorizationsProject;
